import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { PriceTables } from "./components/PriceTables";
import { QuoteSimulator } from "./components/QuoteSimulator";
import { BeforeAfter } from "./components/BeforeAfter";
import { Testimonials } from "./components/Testimonials";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";

function App() {
  return (
    <div className="min-h-screen bg-[#0A1128] text-slate-100 antialiased">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <PriceTables />
        <QuoteSimulator />
        <BeforeAfter />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
